import React, { Fragment, useEffect, useMemo, useState } from "react";
import TopSlidePanel from "../ModalComponente/TopSlidePanel/TopSlidePanel";
import IncluirLeadFormBasico from "./../../../Pages/Operacoes/Lead/LeadFormBasico/Incluir";
import "./WhatsAppConversationActions.css";



const ACTIONS = {
    INCLUIR_LEAD: {
        title: "Incluir Lead",
        height: 500,
        Component: IncluirLeadFormBasico,
    },
    // FUTURO:
    // ANOTACOES: { title: "Ação: Anotações", height: 300, Component: NotesForm },
    // TRANSFERIR: { title: "Ação: Transferir", height: 240, Component: TransferForm },
};

const WhatsAppConversationActions = ({ conversaSelecionada, actionAtivaCallback = (actionAtiva) => { } }) => {
    const [actionAtiva, setActionAtiva] = useState(null);

    // Troca de conversa fecha o painel e reseta a action
    useEffect(() => {
        setActionAtiva(null);
    }, [
        conversaSelecionada?.ddi,
        conversaSelecionada?.ddd,
        conversaSelecionada?.telefone,
    ]);

    const podeAbrirAcoes = !!conversaSelecionada;

    const actionConfig = useMemo(() => {
        actionAtivaCallback(actionAtiva);
        if (!actionAtiva) return null;
        return ACTIONS[actionAtiva] || null;
    }, [actionAtiva]);

    const ActionComponent = actionConfig?.Component;

    const fechar = () => setActionAtiva(null);

    const obterIniciais = (nome) => {
        if (!nome || typeof nome !== "string") return "?";

        const partes = nome.trim().split(/\s+/); // divide ignorando espaços múltiplos

        if (partes.length === 1) {
            return partes[0].charAt(0).toUpperCase();
        }

        const primeira = partes[0].charAt(0).toUpperCase();
        const ultima = partes[partes.length - 1].charAt(0).toUpperCase();

        return primeira + ultima;
    };

    return (
        <div className="wca-actions-root">
            <div className="wca-actions-bar">

                {conversaSelecionada ?
                    <Fragment>
                        <div className="wca-actions-title">
                            <div className="lista-conversas-avatar">
                                <span>{obterIniciais(conversaSelecionada?.nome)}</span>
                            </div>
                            <div className="wca-actions-contact-name">
                                {conversaSelecionada?.nome}
                            </div>
                        </div>

                        {conversaSelecionada.leadId === 0 ?
                            <button
                                type="button"
                                className="btn btn-primary"
                                disabled={!podeAbrirAcoes}
                                title="Incluir Lead"
                                onClick={() => setActionAtiva("INCLUIR_LEAD")}
                            >
                                Incluir Lead
                            </button> : null
                        }

                    </Fragment>
                    : null}
            </div>

            <TopSlidePanel
                open={!!actionAtiva}
                title={actionConfig?.title || "Ações"}
                onClose={fechar}
                height={actionConfig?.height || 180}
            >
                {ActionComponent ? (
                    <ActionComponent conversaSelecionada={conversaSelecionada} onClose={fechar} />
                ) : (
                    <div>Selecione uma ação.</div>
                )}
            </TopSlidePanel>
        </div>
    );
};

export default WhatsAppConversationActions;
